import React, { useState, useEffect } from 'react';
import css from './ProgressBarLevels.css';
import classNames from 'classnames';
/**
 * @param {Object} props
 * @param {number} [props.total=4] - Общее количество уровней (шагов) в прогресс-баре
 * @param {number} [props.level=0] - Текущий активный уровень
 * @param {boolean} [props.editAvailable=true] - Доступно ли изменение уровня кликом/наведением
 * @param {(nextLevel: number) => void} [props.notifyOnPreSelect] - Колбэк при наведении мыши на шаг
 * @param {(baseLevel: number) => void} [props.notifyOnPreSelectOver] - Колбэк при уходе мыши с шага
 * @param {(selectedLevel: number) => void} [props.onLevelSelect] - Колбэк при клике/тапе на шаг
 * @param {string} [props.levelItemClassName] - Кастомный CSS-класс для стандартного элемента шага
 * @param {React.ReactElement} [props.customComponent] - Кастомный React-компонент для рендера шага
 * @param {string} [props.selectedFlag] - Имя пропса (например, 'isActive' или 'checked'), который передается в customComponent для обозначения выделенного состояния
 * @param {string} [props.rootClassName=''] - Кастомный класс для корневого контейнера
 */
const ProgressBarLevels = ({
    total = 4,
    level = 0,
    editAvailable = true,
    notifyOnPreSelect,
    notifyOnPreSelectOver,
    onLevelSelect,
    levelItemClassName,
    customComponent,
    selectedFlag,
    rootClassName = '',
}) => {
    const [currentLevel, setCurrentLevel] = useState(level);

    const levels = Array.from({ length: total });

    useEffect(() => {
        setCurrentLevel(level);
    }, [level]);

    const handlePreSelect = (nextLevel, handler) => {
        if (!editAvailable) {
            return;
        }

        setCurrentLevel(nextLevel);

        if (typeof handler === 'function') {
            handler(nextLevel);
        }
    };

    const getCommonProps = index => ({
        onMouseOver: () => handlePreSelect(index + 1, notifyOnPreSelect),
        onMouseLeave: () => handlePreSelect(level, notifyOnPreSelectOver),
        onClick: () => {
            if (!editAvailable) {
                return;
            }
            onLevelSelect(index + 1);
        },
        onTouchStart: () => {
            if (!editAvailable) {
                return;
            }
            onLevelSelect(index + 1);
        },
    });

    return (
        <div className={rootClassName}>
            {levels.map((_, index) =>
                customComponent && selectedFlag ? (
                    {
                        ...customComponent,
                        key: `level-${index}`,
                        props: {
                            ...customComponent.props,
                            ...getCommonProps(index),
                            [selectedFlag]: index + 1 <= currentLevel,
                        },
                    }
                ) : (
                    <code
                        {...getCommonProps(index)}
                        key={`level-${index}`}
                        className={classNames({
                            [css.level]: !levelItemClassName,
                            [levelItemClassName]: !!levelItemClassName,
                            [css.selected]: index + 1 <= currentLevel,
                            [css.editAvailable]: editAvailable,
                        })}
                    />
                )
            )}
        </div>
    );
};

export default ProgressBarLevels;
